import { buttonVariants } from '@/components/ui/elements/button';
import { useAuthorization } from '@/features/auth/authorization';
import { LinkOptions } from '@tanstack/react-router';
import { VariantProps } from 'cva';
import { Link } from './Link';

export interface LinkProps extends LinkOptions, VariantProps<typeof buttonVariants> {
  policy: string;
  children: React.ReactNode;
  className?: string;
}

export const GatedLink = ({ policy, className, children, ...props }: LinkProps) => {
  const { checkPolicy } = useAuthorization();
  const linkable = checkPolicy({ policy });

  return linkable ? (
    <Link className={className} {...props}>
      {children}
    </Link>
  ) : (
    <span className={className}>{children}</span>
  );
};
